(function() {
	'use strict';

	angular.module('menuApp').controller('MenuDialogController',
			MenuDialogController);

	MenuDialogController.$inject = [ '$scope', '$uibModalInstance',
			'categoryId', 'MenuService' ];

	function MenuDialogController($scope, $uibModalInstance, categoryId,
			MenuService) {
		var vm = this;
		var self = $scope;

		vm.loadPage = function() {
			if (categoryId !== undefined && categoryId !== null
					&& categoryId !== '') {
			}
		}

		vm.deleteMenu = function() {
			MenuService
					.post(
							{
								uri : 'deleteMenu'
							},
							categoryId,
							function(result) {
								$uibModalInstance.close(result);
								self.addAlert('Xóa tin tức thành công.',
										'success');
							},
							function() {
								self
										.addAlert(
												'Có lỗi trong quá trình xử lý, chúng tôi đang cố gắng khắc phục.',
												'danger');
							});
		}
		
		vm.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
